import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Collapse, CardHeader, FormGroup, Button, Input, Label, CardTitle } from "reactstrap";
import { Link } from "react-router-dom";
import Select from 'react-select';
import { MDBDataTableV5 } from "mdbreact";

// RangeSlider
import { CircleSlider } from "react-circle-slider";
import "nouislider/distribute/nouislider.css";
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import "./datatables.scss"
import { internmentUrl, testimonyFormOptionsUrl, internmentFilterUrl } from "../../helpers/url";

class FacilityManager extends Component {
    constructor(props) {
        super(props);
        this.state={
            breadcrumbItems : [
                { title : "Facility", link : "#" },
                { title : "Manager", link : "#" },
            ],

            iconsrc: ["ri-questionnaire-line", " ri-question-line", " ri-eye-off-line", " ri-building-2-line", "ri-building-3-line", "ri-community-line", "ri-search-eye-line", " ri-home-3-line", "ri-lock-2-line", "ri-moon-line", "ri-building-4-line", " ri-moon-clear-line"],

            options: {
                columns: [
                    { label: "ID", field: "facilityId", sort: "asc", width: 20 },
                    { label: "Internal", field: "facilityInternalId", sort: "asc", width: 50 },
                    { label: "Name", field: "facilityName", sort: "asc", width: 50 },
                    { label: "Type", field: "facilityType", sort: "asc", width: 50 },
                    { label: "Established", field: "established", sort: "asc", width: 50 },
                    { label: "Location", field: "degree", sort: "asc", width: 50 },
                    { label: "Link", field: "link", sort: "disabled", width: 50 },
                ],
                rows: []
            },

            typeSec: false,
            violationsSec: false,
            locationsSec: false,
            educationalSec: false,
            religiositySec: false,
            maritalSec: false,
            ethnicitySec: false,
            acquisitionLevelSec: false,
            watchtowersSec: false,
            internalAssesmentSec: false,
            
            data: [],
            value: 0,

            facilityId: 0,

            filterData: [],

            typeFilterOptions: [
                { name: "Not Defined", value: 1 },
                { name: "Jail/Prison", value: 2 },
                { name: "Political 'Re-eductaion' camps", value: 3},
                { name: "XPCC (Bingtuan)", value: 4 },
                { name: "State-run Orphanages", value: 5},
                { name: "Force Labor", value: 10 },
                { name: "Missing", value: 6 },
                { name: "House Arrest", value: 7 },
                { name: "Detained", value: 8 },
                { name: "Dead/Cemetry", value: 9 },
                { name: "Mosque", value: 11 }
            ],
            latestStatusFilterOptions: [],
            latestLocationsOptions: [],
            latestEducationOptions : [],
            latestReligiosityOptions : [],
            latestEthnicityOptions : [],
            latestMaritalOptions : [],

            filter: {
                type: [],
                locations: [],
                sortType: 1,
                acquisitionLevel: 1,
                watchtowers: 0,
                internalAssesmentScore: 0,
            }
        }
    }
    
    handleChange = value => {
        this.setState({filter:{...this.state.filter, watchtowers: parseInt(value)}})
    };
    
    componentDidMount() {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        let fetchData = fetch(internmentUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        
        let fetchFilterOptions = fetch(testimonyFormOptionsUrl, {
            method: "GET",
            headers: {"Content-Type": "application/json", "Authorization": accessToken}
        }).then(res=>res.json())
        
        Promise.all([fetchData, fetchFilterOptions])
        .then(([data, filterOptions]) => {
            var tableRows = {...this.state.options}
            tableRows.rows = data
            tableRows.rows.map( each =>{
                each.facilityType = <i className={this.state.iconsrc[each.facilityType] + " font-size-24"}></i>
                each.link = <Link to={{ pathname: '/facility-detail', state: { facilityId: each.facilityId } }} >
                                View Details
                            </Link>
            })
            this.setState({
                options: tableRows,
                data: data,
                latestStatusFilterOptions: [...filterOptions.victimStatus],
                latestLocationsOptions: [...filterOptions.landCodes]
            })

        })
        .catch(err => {
            console.log("error", err)
        })
    }

    stateSelect = (selected, filterName) => {
        let selectedOptions = []
        selected.map(each => selectedOptions.push(each.value));
			this.setState({
                filter: {...this.state.filter,
                    [filterName]: selectedOptions
                }
			});
    }
    
    stateHandling = (event) => {
        this.setState({filter:{...this.state.filter, acquisitionLevel: parseInt(event.target.value)}})
    }
    
    stateHandlingInternalAssessment = (event) => {
        this.setState({filter:{...this.state.filter, internalAssesmentScore: parseInt(event.target.value)}})
    }

    runThis = () => {
        const jwt = JSON.parse(sessionStorage.getItem("authUser"))
        const accessToken = jwt.jwtToken
        fetch(internmentFilterUrl, { 
            method: "POST",
            headers: {"Content-Type": "application/json", "Authorization": accessToken},
            body: JSON.stringify(this.state.filter),
        })
        .then(res=>res.json())
        .then(response => {
            var tableRows = {...this.state.options}
            tableRows.rows = response
            tableRows.rows.map( each =>{
                each.facilityType = <i className={this.state.iconsrc[each.facilityType] + " font-size-24"}></i>
                each.link = <Link to={{ pathname: '/facility-detail', state: { facilityId: each.facilityId } }} >
                                View Details
                            </Link>
            })
            this.setState({
                successFilter: true,
                data: response,
                options: tableRows,
            })
        })
		.catch(error => {
			console.log(error, "error")
		})
    }
    
    render() {
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>

                    <Breadcrumbs title="Facility Manager" breadcrumbItems={this.state.breadcrumbItems} />

                        <Row>
                            <Col xl={3} lg={4}>
                                <Card>
                                    <CardHeader className="bg-transparent border-bottom">
                                        <h5 className="mb-0">Filters</h5>
                                    </CardHeader>

                                    <CardBody>
                                        <h5 className="font-size-14 mb-3">Categories</h5> 
                                        

                                        <div id="accordion" className="custom-accordion categories-accordion mb-1">
                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({typeSec : !this.state.typeSec, locationsSec : this.state.locationSec})} className={this.state.typeSec ? "categories-group-list accordian-bg-products" : "categories-group-list"}>
                                                    <i className="mdi mdi-alpha-t-box-outline font-size-16 align-middle mr-2"></i> Type
                                                    <i className={this.state.typeSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                        
                                                <Collapse isOpen={this.state.typeSec} id="collapseOne">
                                                    <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.typeFilterOptions.map((option, idx) => ({
                                                            value: option.value,
                                                            label: option.name,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "type");
                                                        }}
                                                    />
                                                </Collapse>
                                            </div>

                                            <div className="categories-group-card">
                                                <Link to="#" onClick={() => this.setState({locationsSec : !this.state.locationsSec, typeSec : false, violationsSec : false})} className={this.state.locationsSec ? "categories-group-list accordian-bg-products" : "categories-group-list"} >
                                                    <i className="mdi mdi-map-marker-multiple-outline font-size-16 align-middle mr-2"></i> Location
                                                    <i className={this.state.locationsSec === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i>
                                                </Link>
                                                <Collapse isOpen={this.state.locationsSec} id="collapseThree">
                                                        <Select
                                                        menuPortalTarget={document.body} 
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        isMulti
                                                        name="colors"
                                                        className="basic-multi-select"
                                                        classNamePrefix="select"
                                                        options={this.state.latestLocationsOptions.map((option, idx) => ({
                                                            value: option.codeId,
                                                            label: option.perfectureCityEN+", "+option.cityCountyEN,
                                                        }))}
                                                        onChange={selected => {
                                                            this.stateSelect(selected, "locations");
                                                        }}/>
                                                </Collapse>
                                            </div>
                                        </div>
                                    </CardBody>

                                    <div className="custom-accordion">
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="text-dark d-block" onClick={() => this.setState({aLevel : !this.state.aLevel})} >Data Acquisition Level <i className={this.state.aLevel === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.aLevel} id="collapseExample1">
                                                        <FormGroup row onChange={event => this.stateHandling(event)}>
                                                    <div className="mt-4">
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={6} id="productdiscountRadio6" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio6">50% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={5} id="productdiscountRadio5" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio5">40% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={4} id="productdiscountRadio4" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio4">30% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productdiscountRadio3" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio3">20% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={2} id="productdiscountRadio2" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio2">10% or higher</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={1} id="productdiscountRadio1" name="acquisition" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productdiscountRadio1">Less than 10%</Label>
                                                        </div>
                                                    </div>
                                                    </FormGroup>
        
                                                </Collapse>
                                            </div>
                                        </CardBody>
    
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="collapsed text-dark d-block" onClick={() => this.setState({rating : !this.state.rating})}>Internal Assesment Rating <i className={this.state.rating === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.rating} id="collapseExample3">
                                                     <FormGroup row onChange={event => this.stateHandlingInternalAssessment(event)}>
                                                    <div className="mt-4">
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={4} id="productratingRadio1" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio1">4 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={3} id="productratingRadio2" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio2">3 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={2} id="productratingRadio3" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio3">2 <i className="mdi mdi-star text-warning"></i>  & Above</Label>
                                                        </div>
                                                        <div className="custom-control custom-radio mt-2">
                                                            <Input type="radio" value={1} id="productratingRadio4" name="productratingRadio1" className="custom-control-input"/>
                                                            <Label className="custom-control-label" htmlFor="productratingRadio4">1 <i className="mdi mdi-star text-warning"></i></Label>
                                                        </div>
                                                    </div>
                                                    </FormGroup>
                                                </Collapse>
                                            </div>
                                        </CardBody>
                                        <CardBody className="border-top">
                                            <div>
                                                <h5 className="font-size-14 mb-0"><Link to="#" className="text-dark d-block" onClick={() => this.setState({size : !this.state.size})}>Watch Towers <i className={this.state.size === true ? "mdi mdi-minus float-right accor-minus-icon" : "mdi mdi-plus float-right accor-plus-icon"}></i></Link></h5>
    
                                                <Collapse isOpen={this.state.size} id="collapseExample2">
        
                                                    <div className="mt-4">
                                                        <Col xl={4} sm={6}>
                                                            <div className="text-center mt-4">

                                                                <div dir="ltr">

                                                                    <CircleSlider showTooltip={true} value={this.state.value} onChange={this.handleChange} />

                                                                </div>
                                                            </div>
                                                        </Col>
                                                    </div>
        
                                                </Collapse>
                                            </div>
                                        </CardBody>
                                        <CardBody className="border-top">
                                            <div>
                                                <Button onClick={this.runThis}>Filter</Button>
                                            </div>
                                        </CardBody>
                                    </div>
                                </Card>
                            </Col>
                            <Col lg={9}>
                                <Card>
                                    <CardBody>
                                        <CardTitle className="h4">Available List of Facilities</CardTitle>
                                        <MDBDataTableV5 
                                            hover
                                            entriesOptions={[10, 15, 25, 50]} 
                                            responsive 
                                            filter='id' // needs pro version
                                            entries={15} 
                                            pagesAmount={10} 
                                            data={this.state.options} 
                                            searchTop 
                                            searchBottom={false}
                                        />
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        
                    </Container> 
                </div>
            </React.Fragment>
        );
    }
}

export default FacilityManager;